import React, { useContext } from 'react'
import "./Main.css"
import Header from '../Components/Header/Header'
import Content from '../Content/Content'
const Main = () => {
  return (
    <div className='main'>
      <Header></Header>
      <Content></Content>
    </div>
  )
}

export default Main;
